import { useRecoilState, atom } from "recoil";

import { IOT_PRODUCTS_LIST } from "../constants/iot.products.constants";

const selectedProductAtom = atom({
    key: "selectedProduct",
    default: IOT_PRODUCTS_LIST[0]
});

const useSelectedProduct = () => {
 const [selectedProduct, setSelectedProduct] = useRecoilState(selectedProductAtom);

 const clearSelectedProduct = () => {
     setSelectedProduct(IOT_PRODUCTS_LIST[0]);
}
 return { selectedProduct, setSelectedProduct, clearSelectedProduct };
}

export default useSelectedProduct;